import { configureStore } from '@reduxjs/toolkit';
import billReportsReducer from './slices/billReportsSlice';
import creditReportsReducer from './slices/creditReportsSlice';
import creditSettlementReportsReducer from './slices/creditSettlementReportsSlice';
import salesReportsReducer from './slices/salesReportsSlice';
import salesReportaReducer from './slices/salesReportaSlice';
import categoryWiseReportsReducer from './slices/categoryWiseReportsSlice';
import itemReportReducer from './slices/itemReportSlice';
import itemOnlineReportReducer from '../components/reports/itemOnlineReport/itemOnlineReportSlice';
import categoryOnlineReportReducer from '../components/reports/categoryOnlineReport/categoryOnlineReportSlice';
import advanceBillReportsReducer from '../components/reports/advanceReport/advanceBillReportsSlice';

import categoryMastersReducer from './slices/categoryReportsSlice';
import companyReducer from './slices/companySlice';
import locationReducer from './slices/locationSlice';
import productCategoryReducer from './slices/productcategorySlice';
import modulegroupReducer from './slices/modulegroupSlice';
import modulemenuReducer from './slices/modulemenuSlice';
import usermodulesReducer from './slices/usermodulesSlice';
import viewAssignedProductReducer from './slices/viewAssignedProductSlice';
import notificationsReducer from './slices/notificationsSlice';
import mobileBillingAppReducer from './slices/mobileBillingAppSlice';
import taxInvoiceReducer from './slices/taxInvoiceSlice';
export const store = configureStore({
    reducer: {
        billReports: billReportsReducer,
        creditReports: creditReportsReducer,
        creditSettlementReports: creditSettlementReportsReducer,
        salesReports: salesReportsReducer,
        salesReporta: salesReportaReducer,
        categoryWiseReports: categoryWiseReportsReducer,
        itemReport: itemReportReducer,
        itemOnlineReport: itemOnlineReportReducer,
        categoryOnlineReport: categoryOnlineReportReducer,
        advanceBillReports: advanceBillReportsReducer,
        categoryMasters: categoryMastersReducer,
        company: companyReducer,
        location: locationReducer,
        productCategory: productCategoryReducer,
        moduleGroup: modulegroupReducer,
        moduleMenu: modulemenuReducer,
        userModules: usermodulesReducer,
        viewAssignedProducts: viewAssignedProductReducer,
        notifications: notificationsReducer,
        mobileBillingApp: mobileBillingAppReducer,
        taxInvoice: taxInvoiceReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types for serializable check (dates are not serializable)
                ignoredActions: [
                    'billReports/setFromDate',
                    'billReports/setToDate',
                    'billReports/setFilters',
                    'creditReports/setFromDate',
                    'creditReports/setToDate',
                    'creditReports/setFilters',
                    'creditSettlementReports/setFromDate',
                    'creditSettlementReports/setToDate',
                    'creditSettlementReports/setFilters',
                    'salesReports/setFromDate',
                    'salesReports/setToDate',
                    'salesReports/setFilters',
                    'salesReporta/setFromDate',
                    'salesReporta/setToDate',
                    'categoryWiseReports/setFromDate',
                    'categoryWiseReports/setToDate',
                    'itemReport/setFromDate',
                    'itemReport/setToDate',
                    'itemOnlineReport/setFromDate',
                    'itemOnlineReport/setToDate',
                    'categoryOnlineReport/setFromDate',
                    'categoryOnlineReport/setToDate',
                    'advanceBillReports/setFromDate',
                    'advanceBillReports/setToDate'
                ],
                // Ignore these paths in the state
                ignoredPaths: [
                    'billReports.fromDate',
                    'billReports.toDate',
                    'creditReports.fromDate',
                    'creditReports.toDate',
                    'creditSettlementReports.fromDate',
                    'creditSettlementReports.toDate',
                    'salesReports.fromDate',
                    'salesReports.toDate',
                    'salesReporta.fromDate',
                    'salesReporta.toDate',
                    'categoryWiseReports.fromDate',
                    'categoryWiseReports.toDate',
                    'itemReport.fromDate',
                    'itemReport.toDate',
                    'itemOnlineReport.fromDate',
                    'itemOnlineReport.toDate',
                    'categoryOnlineReport.fromDate',
                    'categoryOnlineReport.toDate',
                    'advanceBillReports.fromDate',
                    'advanceBillReports.toDate'
                ]
            }
        })
});

export default store;
